<template>
  <div class="progress-barchart-container">
    <!--  标题  -->
    <div class="title-content">
      <p class="title">{{ title }}</p>
      <p v-if="score">
        <span class="score">{{ score }} </span><span class="util">分</span>
      </p>
    </div>
    <!--    进度条柱状图    -->
    <div class="barchart-content" v-if="resultList[0].value||type">
      <div class="barchart-item" v-for="item in resultList" :key="item.name" @click="goToQuestion(item.id,item.name)">
        <p class="name">{{ item.name }}</p>
        <div class="progress">
          <div
            class="progress-entity"
            ref="progressEntity"
            :style="{'width':Number(item.value) * 10 +'%'}"
            :class="{
              'progress-entity-down': parseFloat(item.value) <= 5,
              'progress-entity-over': parseFloat(item.value) == 10,
            }"
          >
            {{ item.value }}
          </div>
        </div>
      </div>
    </div>
    <div class="clickText" v-if="title === '全国冷暖风水服务能力评分'">*点击评分纬度可查看相关高频问题</div>
  </div>
</template>

<script>
export default {
  name: "progressBarchart",
  props: {
    // 这个是项目评分详细要用的传值
    type:{
      type:Boolean,
      default:false,
    },
    // 是否显示标题
    showTitle: {
      type: Boolean,
      default: true,
      name: "progressBarchart",
    },
    // 标题
    title: String,
    // 分数
    score: Number,
    /**
     * 数据
     * @type {
     *     Array<{ name:string; value: number }>
     * }
     */
    resultList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    resultList: function (val) {
      // 设置百分比
      this.$nextTick(() => {
        this.$refs.progressEntity?.forEach((el, index) => {
          console.log(parseFloat(this.resultList[index].value),'value');
          el.style.width = `${parseFloat(this.resultList[index].value) * 10}%`;
        });
      });

      // console.log(this.$route.path,'path');
    },
  },
  computed: {},
  mounted() {},
  methods: {
    goToQuestion(id,name) {
      if (id) {
        //   获取当前路由,判断跳转的位置
        if (this.$route.path === "/hvac/customerscoring/analysis/score") {
          this.$router.push({ path: "/hvac/customerscoring/question", query: { questionTypeId: id } });
        } else if (this.$route.path === "/hvac/agentscore/analysis/score") {
          this.$router.push({ path: "/hvac/agentscore/question", query: { questionTypeId: id } });
        }
      }
      if (name ){
          this.$emit('barchartClick',name)
      }
    },

  },
};
</script>

<style scoped lang="scss">
.progress-barchart-container {
  .title-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: $bigSize;
    color: $deepGreen;
    margin-bottom: 18px;

    .title {
      color: $commonTitle;
      line-height: 48px;
      font-weight: 500;
      font-size: 32px;
      color: #222222;
    }

    .score {
      line-height: 84px;
      font-size: 52px;
      padding: 0 10px;
      font-weight: 500;
      color: #318544;
    }

    .util {
      line-height: 42px;
      display: inline-block;
    }

    p:nth-child(2) {
      display: flex;
      align-items: center;
    }
  }

  .barchart-content {
    .barchart-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 24px;

      .name {
        line-height: 40px;
        font-size: $baseSize;
        flex: 1;

        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #444444;
      }

      .progress {
        width: 376px;
        height: 28px;
        border-radius: 28px;
        background: #f6f6f6;

        .progress-entity {
          width: 0;
          height: 28px;
          border-radius: 28px;
          background: #95cba4;
          line-height: 28px;
          text-align: right;
          padding: 0 16px;
          font-size: $smallSize;
          color: #fff;
          //   transition: width 1s;
        }

        .progress-entity-down {
          background: #e59379;
        }

        .progress-entity-over {
          background: #57ac6f;
        }
      }
    }
  }
  .clickText {
    text-align: center;
    font-size: 24px;
    font-weight: 400;
    color: #c77745;
    line-height: 34px;
    margin-top: 30px;
  }
}
</style>
